/* Vantia – interacciones propias del tema (sin librerías) */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.vt-reveal:not(.vt-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vt-visible');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGaleria(root) {
    var main = root.querySelector('[data-vt-main]');
    var thumbs = root.querySelectorAll('[data-vt-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.dataset.src;
        main.srcset = b.dataset.srcset || '';
        main.alt = b.dataset.alt || main.alt;
        thumbs.forEach(function (x) { x.classList.remove('vt-on'); x.removeAttribute('aria-current'); });
        b.classList.add('vt-on');
        b.setAttribute('aria-current', 'true');
      });
    });
  }

  // Precio, tachado y botón siguen a la variante (pack) elegida
  function initVariantes(root) {
    var form = root.querySelector('[data-vt-form]');
    if (!form) return;
    var botones = root.querySelectorAll('[data-vt-add]');
    var precios = root.querySelectorAll('[data-vt-price]');
    var tachados = root.querySelectorAll('[data-vt-compare]');

    var datos = root.querySelector('[data-vt-variantes]');
    if (!datos) return;
    var variantes = JSON.parse(datos.textContent);
    var grupos = root.querySelectorAll('[data-vt-opcion]');
    var packs = root.querySelectorAll('[data-vt-pack]');
    var inputId = form.querySelector('input[name="id"]');
    var inputCantidad = form.querySelector('[data-vt-cantidad]');
    var main = root.querySelector('[data-vt-main]');

    function variante() {
      if (!grupos.length) return variantes[0];
      var vals = [];
      grupos.forEach(function (g) {
        var c = g.querySelector('input:checked');
        vals[+g.dataset.vtOpcion] = c ? c.value : null;
      });
      return variantes.filter(function (x) {
        return x.options.every(function (o, i) { return o === vals[i]; });
      })[0];
    }
    function pintar(cambiaOpcion) {
      var v = variante();
      var disponible = !!v && v.available;
      var elegido = v;
      // Un pack son varias unidades: su precio depende de la variante elegida (p. ej. el color)
      packs.forEach(function (card, i) {
        var radio = card.querySelector('input');
        var p = v && v.packs[i];
        if (!p) return;
        var ahorro = card.querySelector('[data-vt-pack-ahorro]');
        card.querySelector('[data-vt-pack-precio]').textContent = p.price;
        card.querySelector('[data-vt-pack-compare]').textContent = p.compare;
        ahorro.textContent = p.ahorro ? ahorro.dataset.prefijo + ' ' + p.ahorro : '';
        ahorro.hidden = !p.ahorro;
        if (radio.checked) {
          elegido = p;
          if (inputCantidad) inputCantidad.value = radio.value;
        }
      });
      if (v) {
        inputId.value = v.id;
        precios.forEach(function (el) { el.textContent = elegido.price; });
        tachados.forEach(function (el) { el.textContent = elegido.compare; });
        if (cambiaOpcion && v.imagen && main) { main.src = v.imagen; main.srcset = ''; }
      }
      botones.forEach(function (b) {
        b.disabled = !disponible;
        b.textContent = disponible ? b.dataset.textoAdd : b.dataset.textoAgotado;
      });
    }
    grupos.forEach(function (g) { g.addEventListener('change', function () { pintar(true); }); });
    packs.forEach(function (card) { card.addEventListener('change', function () { pintar(false); }); });
  }

  // "Entrega estimada: 20 de oct – 26 de oct" contando solo días laborables
  function initEntrega(root) {
    var el = root.querySelector('[data-vt-entrega]');
    if (!el) return;
    var min = parseInt(el.dataset.min, 10);
    var max = parseInt(el.dataset.max, 10);
    if (!min || !max || max < min) return;
    var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    function laborable(n) {
      var d = new Date(), k = 0;
      while (k < n) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() % 6) k++;
      }
      // En español se mantiene "20 de oct"; en el resto, el formato propio de cada idioma
      var idioma = (document.documentElement.lang || 'es').toLowerCase();
      if (idioma.indexOf('es') === 0 || !d.toLocaleDateString) return d.getDate() + ' de ' + meses[d.getMonth()];
      return d.toLocaleDateString(idioma, { day: 'numeric', month: 'short' });
    }
    el.textContent = laborable(min) + ' – ' + laborable(max);
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-vt-sticky]');
    var cta = root.querySelector('[data-vt-form] [data-vt-add]');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;
    document.body.classList.add('vt-con-sticky');
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('vt-on', !entries[0].isIntersecting);
    }).observe(cta);
  }

  // Antes y después: la barra es un control deslizante invisible que cubre la imagen
  function initComparador(root) {
    if (root.dataset.vtListo) return;
    root.dataset.vtListo = '1';
    var rango = root.querySelector('input[type="range"]');
    if (!rango) return;
    rango.addEventListener('input', function () {
      root.style.setProperty('--vt-pos', rango.value + '%');
    });
  }

  // Seguimiento: abre el número en el rastreador externo configurado en la sección
  function initSeguimiento(form) {
    if (form.dataset.vtListo) return;
    form.dataset.vtListo = '1';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var numero = form.querySelector('input').value.trim();
      if (numero) window.open(form.dataset.url + encodeURIComponent(numero), '_blank', 'noopener');
    });
  }

  function initMenu(menu) {
    if (menu.dataset.vtListo) return;
    menu.dataset.vtListo = '1';
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) menu.removeAttribute('open');
    });
    document.addEventListener('click', function (e) {
      if (menu.open && !menu.contains(e.target)) menu.removeAttribute('open');
    });
  }

  // Vídeos: suenan siempre en silencio, arrancan al entrar en pantalla y se pueden pausar
  function initVideo(caja) {
    if (caja.dataset.vtListo) return;
    caja.dataset.vtListo = '1';
    var video = caja.querySelector('video');
    var btn = caja.querySelector('[data-vt-video-btn]');
    if (!video) return;
    var fin = parseFloat(caja.dataset.fin) || 0;
    var menosMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = caja.dataset.auto !== 'false' && !menosMovimiento;
    var pausadoAMano = false;

    function pintar() {
      var sonando = !video.paused;
      caja.classList.toggle('vt-on', sonando);
      if (btn) btn.setAttribute('aria-label', sonando ? btn.dataset.pause : btn.dataset.play);
    }
    function reproducir() {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    video.muted = true;
    video.addEventListener('play', pintar);
    video.addEventListener('pause', pintar);
    if (fin > 0) {
      // Corta el final que no interesa y vuelve a empezar
      video.addEventListener('timeupdate', function () {
        if (video.currentTime >= fin) video.currentTime = 0;
      });
    }
    if (btn) {
      btn.addEventListener('click', function () {
        if (video.paused) {
          pausadoAMano = false;
          reproducir();
        } else {
          pausadoAMano = true;
          video.pause();
        }
      });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) video.pause();
        else if (auto && !pausadoAMano) reproducir();
      }, { threshold: 0.4 }).observe(caja);
    }
    pintar();
  }

  // Fotos en grande: al tocar la foto principal se abre a pantalla completa
  function initLightbox(root) {
    var lb = root.querySelector('[data-vt-lb]');
    var abrir = root.querySelector('[data-vt-lb-abrir]');
    var main = root.querySelector('[data-vt-main]');
    if (!lb || !abrir || !main || !lb.showModal) return;
    var img = lb.querySelector('[data-vt-lb-img]');
    var cuenta = lb.querySelector('[data-vt-lb-cuenta]');
    var escena = lb.querySelector('[data-vt-lb-escena]');
    var thumbs = Array.prototype.slice.call(lb.querySelectorAll('[data-vt-lb-thumb]'));
    var actual = 0;
    if (!thumbs.length) return;

    function archivo(url) {
      return (url || '').split('?')[0].split('/').pop();
    }
    function mostrar(i) {
      actual = (i + thumbs.length) % thumbs.length;
      var t = thumbs[actual];
      img.src = t.dataset.src;
      img.alt = t.dataset.alt || '';
      thumbs.forEach(function (x, k) {
        x.classList.toggle('vt-on', k === actual);
        if (k === actual) x.setAttribute('aria-current', 'true');
        else x.removeAttribute('aria-current');
      });
      if (cuenta) cuenta.textContent = thumbs.length > 1 ? actual + 1 + ' / ' + thumbs.length : '';
      if (t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center' });
    }

    abrir.addEventListener('click', function () {
      // Empieza por la foto que se está viendo en la galería
      var nombre = archivo(main.currentSrc || main.src);
      var i = 0;
      thumbs.forEach(function (t, k) {
        if (archivo(t.dataset.src) === nombre) i = k;
      });
      lb.showModal();
      document.documentElement.classList.add('vt-sin-scroll');
      mostrar(i);
    });
    lb.addEventListener('close', function () {
      document.documentElement.classList.remove('vt-sin-scroll');
      // La galería se queda en la última foto vista
      var fuera = root.querySelectorAll('[data-vt-thumb]');
      if (fuera[actual]) fuera[actual].click();
    });
    lb.querySelector('[data-vt-lb-cerrar]').addEventListener('click', function () { lb.close(); });
    var ant = lb.querySelector('[data-vt-lb-ant]');
    var sig = lb.querySelector('[data-vt-lb-sig]');
    if (ant) ant.addEventListener('click', function () { mostrar(actual - 1); });
    if (sig) sig.addEventListener('click', function () { mostrar(actual + 1); });
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { mostrar(k); });
    });
    // Tocar fuera de la foto cierra
    escena.addEventListener('click', function (e) {
      if (e.target === escena) lb.close();
    });
    lb.addEventListener('keydown', function (e) {
      if (thumbs.length < 2) return;
      if (e.key === 'ArrowLeft') mostrar(actual - 1);
      if (e.key === 'ArrowRight') mostrar(actual + 1);
    });
    // Deslizar con el dedo para pasar de foto
    var x0 = null;
    var y0 = null;
    escena.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    escena.addEventListener('touchend', function (e) {
      if (x0 === null || thumbs.length < 2) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) mostrar(actual + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  function initProducto(root) {
    if (root.dataset.vtListo) return;
    root.dataset.vtListo = '1';
    initGaleria(root);
    initLightbox(root);
    initVariantes(root);
    initEntrega(root);
    initSticky(root);
  }

  // Contador de la cesta: salta cuando sube el número de artículos
  function initCesta() {
    var caja = document.getElementById('cart-icon-bubble');
    if (!caja || caja.dataset.vtListo) return;
    caja.dataset.vtListo = '1';
    function cuenta() {
      var n = caja.querySelector('.cart-count-bubble span[aria-hidden]');
      return n ? parseInt(n.textContent, 10) || 0 : 0;
    }
    function guardar(n) {
      try { sessionStorage.setItem('vt-cesta', n); } catch (e) { /* sin almacenamiento: no pasa nada */ }
    }
    function saltar() {
      var b = caja.querySelector('.cart-count-bubble');
      if (!b) return;
      b.classList.remove('vt-salta');
      void b.offsetWidth; // reinicia la animación si ya estaba puesta
      b.classList.add('vt-salta');
    }
    var antes = null;
    try { antes = sessionStorage.getItem('vt-cesta'); } catch (e) { /* igual que arriba */ }
    var ahora = cuenta();
    // Al añadir se pasa a la página del carrito: el salto se ve al llegar
    if (antes !== null && ahora > +antes) setTimeout(saltar, 350);
    guardar(ahora);
    // En el carrito, Dawn repinta el contador al cambiar las cantidades
    new MutationObserver(function () {
      var n = cuenta();
      if (n === ahora) return;
      if (n > ahora) saltar();
      ahora = n;
      guardar(n);
    }).observe(caja, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    initCesta();
    document.querySelectorAll('[data-vt-producto]').forEach(initProducto);
    document.querySelectorAll('[data-vt-video]').forEach(initVideo);
    document.querySelectorAll('[data-vt-menu]').forEach(initMenu);
    document.querySelectorAll('[data-vt-comparador]').forEach(initComparador);
    document.querySelectorAll('[data-vt-seguimiento]').forEach(initSeguimiento);
    initReveal();
  }

  // Selector de idioma: el desplegable se cierra al tocar fuera o con Escape
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-vt-idioma][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-vt-idioma][open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // El editor de Shopify vuelve a pintar las secciones al cambiar ajustes
  document.addEventListener('shopify:section:load', init);
})();
